import React from "react";
import moment from "moment";
import { HiExclamation } from "react-icons/hi";
import AttachmentContainer from "../groupChat/attachmentContainer";
import MarkdownToHtml from "../../components/markdownToHtml";
import { highlightMentionText, isLoggedInUser, TimeAgo } from "../../helpers/utility";

const HistoryMessage = ({ msg, authData }) => {
  const isOwnMessage = isLoggedInUser(authData, msg);
  const msgText = msg?.message?.text ? msg.message.text.replaceAll("\n", "<br>") : "";
  const eventTitle = msg?.message?.event_type ? msg.message.event_type.replaceAll("_", " ") : "";
  const createdAt = msg?.created ? new Date(msg.created) : null;

  const isOpenInPreview = () => false;

  return (
    <div className={`flex gap-3 pb-4 ${isOwnMessage ? "flex-row-reverse text-start" : "w-full"}`}>
      <div className={isOwnMessage ? "text-right" : "text-left"}>
        <h2 className="text-sm font-semibold">
          {isOwnMessage ? null : msg?.sender}
          <span className="ml-1 text-xs text-gray-500">
            {createdAt ? <TimeAgo date={createdAt} /> : null}
          </span>
        </h2>
        <div className={`mt-1 rounded-md p-2 shadow ${isOwnMessage ? "bg-blue-100" : "bg-light-gray-f1 border"}`}>
          {eventTitle ? (
            <h1 className="mb-1 border-b px-2 py-1 font-bold capitalize">{eventTitle}</h1>
          ) : null}
          {msg?.message?.data?.start_time ? (
            <p className="mb-1 text-left text-gray-800">On: {moment(msg.message.data.start_time).format("MM/DD/YYYY hh:mm A")}</p>
          ) : null}
          {msgText ? (
            <div className="flex items-center gap-2 text-left text-gray-800">
              <MarkdownToHtml markdownText={highlightMentionText(msgText)} />
              {(msg?.message?.urgent || msg?.urgent) ? <HiExclamation title="Urgent Message" className="text-red-500" /> : null}
            </div>
          ) : null}
          {msg?.message?.media?.length ? (
            <div className="mt-2">
              <AttachmentContainer data={{ files: msg.message.media }} openInEditor={isOpenInPreview()} stackFiles />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HistoryMessage;
